// prettier-ignore
export const PIK_LANDING_QS = 'deal_type=sale&engine_version=2&from_developer=1&builder=9&offer_type=flat&with_newobject=1&object_type%5B0%5D=2&location%5B1%5D=1&location%5B0%5D=4593&is_pik_promo=1';
export const PIK_LANDING_PATH = `/cat.php?${PIK_LANDING_QS}`;
